import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormBuilder, FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { RouterModule } from '@angular/router';
import { MaterialModule } from 'src/app/material.module';
import { ToastService } from '../../../services/toast.service';

@Component({
  selector: 'app-agent-detail',
  imports: [CommonModule, RouterModule, MaterialModule, FormsModule],
  templateUrl: './agent-detail.component.html',
  styleUrl: './agent-detail.component.scss'
})
export class AgentDetailComponent {
  constructor(
    private fb: FormBuilder,
    private toastService: ToastService,
    public dialogRef: MatDialogRef<AgentDetailComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: any
  ) { }
}
